import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import {
  FieldTooltip,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { PlusIcon } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import RecipientList from "../list/list";
import RecipientDashboard from "../dashboard/dashboard";

const RecipientListLanding = () => {
  const CreateRecipientListButton = () => {
    const navigate = useNavigate();

    const handleCreateTemplate = () => {
      navigate("/communication-hub/recipient-list/add");
    };

    return (
      <Button onClick={handleCreateTemplate}>
        <PlusIcon className="h-4 w-4 mr-2" />
        Add List
      </Button>
    );
  };
  return (
    <div className="space-y-6 p-1">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <PageHeader
            title="Recipient Lists"
            subtitle="Manage all recipient lists across your templates"
          />
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <CreateRecipientListButton />
            </TooltipTrigger>
            <FieldTooltip>Create a new recipient list</FieldTooltip>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="mt-1">
        <RecipientDashboard />
      </div>
      <div className="mt-1">
        <RecipientList />
      </div>
    </div>
  );
};

export default RecipientListLanding;
